import { render, staticRenderFns } from "./MergePPTXModal.vue?vue&type=template&id=0f3434f4&scoped=true"
import script from "./MergePPTXModal.vue?vue&type=script&lang=js"
export * from "./MergePPTXModal.vue?vue&type=script&lang=js"
import style0 from "./MergePPTXModal.vue?vue&type=style&index=0&id=0f3434f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3434f4",
  null
  
)

export default component.exports